import React from 'react';
import ProListingSuccess from 'assets/marketing/prolisting-success.png';
import s from './s.module.less';
import { PATH } from 'constants/path';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';

const ProListingSetupSuccess = () => {
    const navigate = useNavigate();

    return (
        <div className={s.wrap}>
            <div className={s.header}>
                <img
                    onClick={() => {
                        navigate(PATH.DASHBOARD);
                    }}
                    src="https://saas-prod-us.s3.us-east-2.amazonaws.com/prod/ui/logo_kiwihealth_by_klarity_380x96.png"
                    className={s.logo}
                    alt="Kiwi Health Logo"
                />
            </div>
            <div className={s.content}>
                <img src={ProListingSuccess} className={s.successImg} alt="Pro Listing Setup Success Icon" />
                <div className={s.title}>You’re enrolled in Pro-Listings</div>
                <div className={s.description}>
                    Your Pro-Listings are now live and can help you reach more patients. Klarity will use your bid and budget settings to determine where and when to show your services.
                </div>
                <div className={s.description}>
                    You can track performance and adjust your bid or budget anytime.
                </div>
                <Button
                    type="primary"
                    onClick={() => {
                        navigate(`${PATH.DASHBOARD}/${PATH.MARKETING}`);
                    }}
                    size="large"
                    style={{ width: '353px' }}
                >Back to Klarity marketing
                </Button>
            </div>
        </div>
    );
};

export default ProListingSetupSuccess;
